import axios from "axios";
import models from "../../models/gestionTiempos/models";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getLiquidationModels() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/modelos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return models.fromJson(item);
      })
    );
  }

  getLiquidationModelId(liquidationid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/modelos/${liquidationid}`, { headers })
      .then(({ data }) => data);
  }

  addLiquidationModel(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
      frecuencia: data.frecuencia,
      diaInicio: Number(data.diaInicio),
      mes: data.meses,
      topeMaxHExtras: Number(data.topeMaxHExtras),
      tipoModeloId: 1,
    };

    return axios.post(`${url}/modelos`, payload, { headers });
  }

  editLiquidationModel(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {};

    if (data.name) {
      payload.nombre = data.name;
    }

    if (data.frecuencia !== undefined) {
      payload.frecuencia = data.frecuencia;
    }

    if (data.diaInicio) {
      payload.diaInicio = data.diaInicio;
    }

    if (data.meses) {
      payload.mes = data.meses;
    }

    if (data.activa) {
      payload.activa = data.activa;
    }

    if (data.topeMaxHExtras) {
      payload.topeMaxHExtras = data.topeMaxHExtras;
    }

    if (data.tipoModeloId) {
      payload.tipoModeloId = data.tipoModeloId;
    }

    return axios
      .patch(`${url}/modelos/${data.liqModeloId}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteLiquidationModel(liqmodeloid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/modelos/${liqmodeloid}`, { headers });
  }

  addInstanceToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      fecDesde: data.dateStart + "T00:00:00.000Z",
      fecHasta: moment(data.dateEnd).format("YYYY-MM-DD") + "T00:00:00.000Z",
      repiteXanio: data.repitXyear,
      nombre: data.name,
      topeMaxHExtras: Number(data.overtimeLimit),
    };

    return axios.post(`${url}/modelos/instancias`, payload, { headers });
  }

  editInstanceToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {};

    if (data.dateStartInput !== undefined) {
      payload.fecDesde = data.dateStartInput + "T00:00:00.000Z";
    }

    if (data.dateEndInput !== undefined) {
      payload.fecHasta =
        moment(data.dateEndInput).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    if (data.repitXyear == true || data.repitXyear == false) {
      payload.repiteXanio = data.repitXyear;
    }

    if (data.name !== undefined) {
      payload.nombre = data.name;
    }

    if (data.overtimeLimit !== undefined) {
      payload.topeMaxHExtras = Number(data.overtimeLimit);
    }

    return axios
      .patch(
        `${url}/modelos/instancias/${data.liqModeloId}&${data.fecDesdeOld}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteInstanceToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/instancias/${data.liqModeloId}&${
        data.dateStartInput + "T00:00:00.00Z"
      }`,
      { headers }
    );
  }

  //Conceptos
  addConceptToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      conceptoId: Number(data.idConcept),
      autoriza: Number(data.idAutorizacion),
    };
    return axios.post(`${url}/modelos/conceptos`, payload, { headers });
  }

  editConceptToLiquidation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      autoriza: Number(data.autoriza),
    };

    return axios
      .patch(
        `${url}/modelos/conceptos/${data.liqModeloId}&${data.id}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteConceptToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/conceptos/${data.liqModeloId}&${data.id}`,
      { headers }
    );
  }

  //centro de costos
  addCostCenterToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      csCostos: [Number(data.idConcept)],
    };

    return axios.post(`${url}/modelos/cscostos`, payload, { headers });
  }

  deleteCostCenterToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/cscostos/${data.liqModeloId}&${data.id}`,
      { headers }
    );
  }

  // Empleados
  addEmployeeToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      empId: Number(data.idEmployee),
      fecDesde: data.dateStart + "T00:00:00.000Z",
    };

    if (data.dateEnd !== null) {
      payload.fecHasta =
        moment(data.dateEnd).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios.post(`${url}/modelos/empleados`, payload, { headers });
  }

  editEmployeeToLiquidation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};
    if (data.dateStartInput !== undefined) {
      payload.fecDesde = data.dateStartInput + "T00:00:00.000Z";
    }

    if (data.dateEndInput !== undefined) {
      payload.fecHasta =
        moment(data.dateEndInput).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios
      .patch(
        `${url}/modelos/empleados/${data.liqModeloId}&${Number(data.id)}&${
          data.fecDesdeOld
        }`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteEmployeeToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/empleados/${data.liqModeloId}&${data.id}&${
        data.dateStartInput + "T00:00:00.00Z"
      }`,
      { headers }
    );
  }

  //Grupos
  addGroupToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      grupoId: Number(data.id),
      fecDesde: data.dateStart + "T00:00:00.000Z",
    };

    if (data.dateEnd !== null) {
      payload.fecHasta =
        moment(data.dateEnd).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios.post(`${url}/modelos/grupos`, payload, { headers });
  }

  editGroupToLiquidation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};
    if (data.dateStartInput !== undefined) {
      payload.fecDesde = data.dateStartInput + "T00:00:00.000Z";
    }

    if (data.dateEndInput !== undefined) {
      payload.fecHasta =
        moment(data.dateEndInput).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios
      .patch(
        `${url}/modelos/grupos/${data.liqModeloId}&${Number(data.id)}&${
          data.fecDesdeOld
        }`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteGroupToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/grupos/${data.liqModeloId}&${data.id}&${
        data.dateStartInput + "T00:00:00.00Z"
      }`,
      { headers }
    );
  }
  //Firmas

  addFirmToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      orden: Number(data.order),
      operId: Number(data.operId),
    };

    return axios.post(`${url}/modelos/firmas`, payload, { headers });
  }

  editFirmToLiquidation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    if (data.order !== null) {
      payload.orden = Number(data.order);
    }

    if (data.operId) {
      payload.operId = Number(data.operId);
    }

    return axios
      .patch(
        `${url}/modelos/firmas/${data.liqModeloId}&${Number(data.orderOld)}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteFirmToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/firmas/${data.liqModeloId}&${Number(data.order)}`,
      { headers }
    );
  }

  //Reglas de pre liquidacion

  addRulePreLiquidationToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      accion: data.regla,
    };
    if (data.tolerancia) {
      payload.cantHoras = data.tolerancia;
    }
    // Verificar si conceptoId_1 está definido en data antes de agregarlo
    if (data.conceptoId_1) {
      payload.conceptoId_1 = Number(data.conceptoId_1);
    }

    // Verificar si conceptoId_2 está definido en data antes de agregarlo
    if (data.conceptoId_2) {
      payload.conceptoId_2 = Number(data.conceptoId_2);
    }

    // Verificar si csCostoId_1 está definido en data antes de agregarlo
    if (data.csCostoId_1) {
      payload.csCostoId_1 = Number(data.csCostoId_1);
    }

    // Verificar si csCostoId_2 está definido en data antes de agregarlo
    if (data.csCostoId_2) {
      payload.csCostoId_2 = Number(data.csCostoId_2);
    }

    return axios.post(`${url}/modelos/reglaspreliq`, payload, { headers });
  }

  editRulePreLiquidationLiquidation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      accion: data.regla,
    };
    if (data.tolerancia) {
      payload.cantHoras = Number(data.tolerancia);
    } else {
      payload.cantHoras = null;
    }
    // Verificar si conceptoId_1 está definido en data antes de agregarlo
    if (data.conceptoId_1) {
      payload.conceptoId_1 = Number(data.conceptoId_1);
    }

    // Verificar si conceptoId_2 está definido en data antes de agregarlo
    if (data.conceptoId_2) {
      payload.conceptoId_2 = Number(data.conceptoId_2);
    }

    // Verificar si csCostoId_1 está definido en data antes de agregarlo
    if (data.csCostoId_1) {
      payload.csCostoId_1 = Number(data.csCostoId_1);
    }

    // Verificar si csCostoId_2 está definido en data antes de agregarlo
    if (data.csCostoId_2) {
      payload.csCostoId_2 = Number(data.csCostoId_2);
    }

    return axios
      .patch(
        `${url}/modelos/reglaspreliq/${data.liqModeloId}&${data.regla}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteRulePreLiquidationToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/reglaspreliq/${data.liqModeloId}&${data.accion}`,
      { headers }
    );
  }

  //Reglas de liquidacion

  addRuleLiquidationToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      orden: Number(data.order),
      reglaLiqId: Number(data.reglaLiqId),
    };

    return axios.post(`${url}/modelos/reglasliq`, payload, { headers });
  }

  editRuleLiquidationToLiquidation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      orden: Number(data.order),
    };

    return axios
      .patch(
        `${url}/modelos/reglasliq/${data.liqModeloId}&${data.id}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteRuleLiquidationToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/reglasliq/${data.liqModeloId}&${data.id}`,
      { headers }
    );
  }

  //Reglas de ajustes

  addRuleAdjustmentToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      liqModeloId: data.liqModeloId,
      orden: Number(data.order),
      nomProc: data.nameProcedure,
      descrip: data.description,
      activa: data.activa === "true" ? true : false,
    };

    return axios.post(`${url}/modelos/ajustes`, payload, { headers });
  }

  editRuleAdjustmentToLiquidation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    if (data.nameProcedure) {
      payload.nomProc = data.nameProcedure;
    }
    if (data.description) {
      payload.descrip = data.description;
    }
    if (data.activa == true || data.activa == false) {
      payload.activa = data.activa;
    }
    if (data.order) {
      payload.orden = Number(data.order);
    }

    return axios
      .patch(
        `${url}/modelos/ajustes/${data.liqModeloId}&${data.orderOld}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteRuleAdjustmentToLiquidation(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/modelos/ajustes/${data.liqModeloId}&${data.order}`,
      { headers }
    );
  }

  //Reglas de distribucion de horas
}

export default service;
